import { CSSProperties } from "react";
import { Button, Layout } from "antd";
import styled from "styled-components";
import theme from "styles/theme";
const { Header } = Layout;

export const HeaderFix = styled(Header)`
  background-color: ${(props) => props.theme["@header-background"]};
  width: calc(100%);
  box-shadow: 0 3px 10px ${(props) => props.theme["@box-shadow"]};
  padding: 0;
  position: absolute;
  z-index: 3;
  display: inline-grid;
  grid-template-columns: auto 1fr auto;
  grid-template-rows: 1fr;
  grid-column-gap: 0;
  grid-row-gap: 0px;
  place-items: center;
  height: 60px;
  position: fixed;
`;

export const Logo = styled.div`
  width: 100%;
  display: grid;
  place-items: center;
  margin-left: 75px;
  .image-log {
    color: ${(props) => props.theme["@primary-color-brand"]} !important;
  }
`;

export const Perfil = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 0.2fr 0.2fr auto 0.2fr auto 0.4fr;
  grid-template-rows: 1fr;
  grid-column-gap: 1px;
  grid-row-gap: 0px;
  place-items: center;
  margin: 0 10px;
  .username,
  .location {
    justify-self: left;
    margin-left: 10px;
    float: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: ${(props) => props.theme["@medium-font-size"]} !important;
    font-weight: 200;
    color: ${(props) => props.theme["@profile-text-color"]};
    font-family: ${(props) => props.theme["@font-family"]};
  }
  .notification {
    :hover {
      .ant-badge-count {
        background-color: ${(props) => props.theme["@primary-color-brand"]} !important;
      }
    }
  }
  .avatarNotification {
    color: ${(props) => props.theme["@primary-color-brand"]} !important;
    :hover {
      .bellIcon {
        color: ${(props) => props.theme["@primary-color-brand"]} !important;
      }
    }
  }
  .notification {
    margin-right: 20px;
    color: ${(props) => props.theme.colors.text};
    &:hover {
      cursor: pointer;
    }
  }
  .bellIcon {
    color: ${(props) => props.theme.colors.text};
    :hover {
      color: ${(props) => props.theme["@primary-color-brand"]} !important;
    }
  }
  .logout {
    color: ${(props) => props.theme.colors.manatee};
    margin-top: -3px;
    &:hover {
      color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }
  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
    outline: 1.6px solid ${(props) => props.theme.colors.text} !important;
    box-shadow: none !important;
    outline-offset: 1.6px !important;
  }
`;

export const NotificationIcon: CSSProperties = {
  color: theme.colors.text,
};

export const NotificationBox = styled.div`
  margin-left: 10px;
`;

export const ButtonLogout = styled(Button)`
  margin-right: 25px;
`;

export const Avatar: React.CSSProperties = {
  backgroundColor: theme["@avatar-background"],
};

export const InfoIcon: React.CSSProperties = {
  color: theme.colors.text,
  marginTop: "7px",
};
